
import { Options, Prop, Vue, Watch } from "vue-property-decorator";
@Options({
  emits: ["update:modelValue"],
})
export default class Tirscript3CheckBoxComponent extends Vue {
  @Prop({ type: Boolean }) modelValue: boolean;
  @Prop({ type: Boolean, default: false }) disabled: boolean;

  innerChecked: boolean = false;
  innerDisabled: boolean = false;

  @Watch("disabled") onChangeDisabled(value: boolean) {
    this.innerDisabled = value;
  }
  @Watch("modelValue")
  onModelValueChanged() {
    this.innerChecked = this.modelValue;
  }
  @Watch("innerChecked")
  onInnerCheckedChanged() {
    if (this.innerChecked != this.modelValue)
      this.$emit("update:modelValue", this.innerChecked);
  }
  created() {}
  mounted() {
    this.innerChecked = this.modelValue;
    this.innerDisabled = this.disabled;
  }
  onClick() {
    if (this.innerDisabled) {
      return;
    }
    this.innerChecked = !this.innerChecked;
    this.$emit("change", this.innerChecked);
  }
}
